import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer, CartV2Actions } from '@grandvisionhq/analytics';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { isNil } from '@grandvisionhq/utils';
import { useCartStorage } from './use-cart-storage.js';
import { mapLineItemToDataLayerEvent } from '../mappers/analytics/data-layer/line-item-to-data-layer-event.js';
import { createProductObject } from '../mappers/analytics/structured-data-mapper.js';
import { getValidationErrorCodes } from '../utils/get-validation-error-codes.js';
import { UPDATE_CART_LINE_ITEMS } from '../operations/mutations/update-cart-line-items.js';
import { GET_CART } from '../operations/queries/get-cart.js';

const useUpdateLineItemQuantity = (lineItem)=>{
    const [{ cartId  }, { setCartCount  }] = useCartStorage();
    const [quantityDiff, setQuantityDiff] = React.useState(0);
    const handleValidationErrors = (validationErrors)=>{
        validationErrors.forEach((validationError)=>toast.failed(`cart.${validationError}`)
        );
    };
    const [updateCartItems, updateQuantityMutation] = useMutation(UPDATE_CART_LINE_ITEMS, {
        onCompleted: ()=>{
            if (quantityDiff === 0) {
                return;
            }
            const id = cartId || '';
            const eventType = quantityDiff > 0 ? DataLayer.DataLayerTypes.EventType.add : DataLayer.DataLayerTypes.EventType.remove;
            const dataLayerEvents = mapLineItemToDataLayerEvent(eventType, [
                swcHelpers.objectSpread({}, lineItem, {
                    quantity: Math.abs(quantityDiff)
                })
            ], id);
            dataLayerEvents && DataLayer.pushEcommerceEvent(dataLayerEvents);
            CartV2Actions.updateQuantitySdAction([
                {
                    object: createProductObject(lineItem),
                    updateType: quantityDiff > 0 ? 'increase' : 'decrease'
                }, 
            ]);
        },
        refetchQueries: [
            'GetCart'
        ]
    });
    const updateItemQuantity = React.useCallback((updatedQuantity)=>{
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        setQuantityDiff(updatedQuantity - lineItem.quantity);
        updateCartItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItem.id,
                            quantity: updatedQuantity
                        }, 
                    ]
                }
            },
            update (cache, { data  }) {
                if (data && data.updateCartLineItems.success === true) {
                    const newCart = data.updateCartLineItems.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: {
                            id: cartId
                        },
                        data: newCart
                    });
                    setCartCount((newCart === null || newCart === void 0 ? void 0 : newCart.numberOfItems) || 0);
                }
                if (data && !data.updateCartLineItems.success) {
                    const validationErrors = getValidationErrorCodes(data.updateCartLineItems.validationErrors);
                    handleValidationErrors(validationErrors);
                }
            }
        });
    }, [
        cartId,
        lineItem,
        setCartCount,
        updateCartItems
    ]);
    const { called , loading , error  } = updateQuantityMutation;
    return [
        updateItemQuantity,
        {
            called,
            loading,
            error
        }
    ];
};

export { useUpdateLineItemQuantity };
//# sourceMappingURL=use-update-line-item-quantity.js.map
